export default function(airlines, age, nationality) {
  let containsSpecifiedAirline = false

  if (airlines.includes("WZ")) containsSpecifiedAirline = true
  if (airlines.includes("2G")) containsSpecifiedAirline = true
  if (airlines.includes("Y7")) containsSpecifiedAirline = true

  return containsSpecifiedAirline && nationality === "ru" && typeof age === "number" && age <= 12
}
